import Fancybox from 'fancybox';
const Layout = ( $ ) => {
	Fancybox.bind("[data-fancybox]");
	const textSectionUl = $(".text-section ul");
	if (textSectionUl.length) {
		if(textSectionUl.children().length === 4){
			textSectionUl.addClass('four-items')
		}
	}

	// Input focus
	const input = $('.input input');
	const selectEl = $('select')
	if ( input.length ) {
		input.focus( function() {
			$( this ).parent().addClass( 'focus' );
		} );
		input.blur( function() {
			if ( $( this ).val().length === 0 ) {
				$( this ).parent().removeClass( 'focus' );
			}
		} );
		input.each( function() {
			if ( $( this ).val().length === 0 ) {
				$( this ).parent().removeClass( 'focus' );
			} else {
				$( this ).parent().addClass( 'focus' );
			}
		} );
	}
	//*Cursor Start*//
	if ($('#cursor').length === 0) {
		$('html').append('<span id="cursor" class="hide"></span>');
	}
	const cursor = $('#cursor');
	const cursorEl = cursor[0];
	cursor.show();

	let mouse = { x: -100, y: -100 };
	let firstMove = true;
	const interactiveSelector = 'a, button, .button, .menu-button, .slick-arrow, input, select, textarea, label, [role="button"], .submit, .btn, .selectric';

	const renderCursor = (x, y) => {
		if (cursorEl) {
			cursorEl.style.transform = `translate3d(${x - 7.5}px, ${y - 7.5}px, 0)`;
		}
	};

	const updateCoordinates = e => {
		if (!e) return;
		const x = e.clientX ?? e.originalEvent?.clientX;
		const y = e.clientY ?? e.originalEvent?.clientY;

		if (typeof x === 'number' && !isNaN(x) && typeof y === 'number' && !isNaN(y)) {
			mouse.x = x;
			mouse.y = y;
			renderCursor(x, y);
			if (firstMove) {
				firstMove = false;
			}
		}

		if (mouse.x < 0 || mouse.y < 0) return;

		const target = (e.target && e.target !== document && e.target !== window)
			? e.target
			: document.elementFromPoint(mouse.x, mouse.y);

		const isInteractive = target && $(target).closest(interactiveSelector).length > 0;

		if (isInteractive) {
			cursor.addClass('hide');
		} else if (!firstMove) {
			cursor.removeClass('hide');
		}
	};

	const handleScroll = () => {
		if (mouse.x >= 0 && mouse.y >= 0 && !firstMove) {
			const target = document.elementFromPoint(mouse.x, mouse.y);
			const isInteractive = target && $(target).closest(interactiveSelector).length > 0;
			if (isInteractive) {
				cursor.addClass('hide');
			} else {
				cursor.removeClass('hide');
			}
		}
	};

	window.addEventListener('mousemove', updateCoordinates, { passive: true });
	window.addEventListener('scroll', handleScroll, { passive: true });

	$(document).on('mouseleave', function() {
		cursor.addClass('hide');
	}).on('mouseenter', function(e) {
		updateCoordinates(e);
	});
	//*Cursor End*//
	const animateElements = $('.animate__animated');
	animateElements.each(function() {
		new Waypoint({
			element: this,
			handler: function() {
				$(this.element).addClass('animate__fadeInUp')
			},
			offset: '95%',
			group: 'animateElements'
		})
	})
	if($(window).width() < 768){
		const rightBlock = $('.info .right-block:last-of-type');
		const notificationWrapper = $('.notification-wrapper');
		$(rightBlock).each(function(){
			const pEl = $(this).find('p');
			$(this).prev().find('h2.title').after(pEl);
		});
		const footerMd4 = $('footer .col-md-4 h3.title');
		const footerForm = $('footer .col-md-8');
		footerMd4.before(footerForm);
		if(notificationWrapper.length){
			$('.dashboard-menu').before(notificationWrapper);
		}


	}
	if (selectEl.length) {
		selectEl.selectric({
			arrowButtonMarkup: '<i class="icon-chevron-down"></i>',
			nativeOnMobile: false,
		});
	}

	const formSubmit = $('#wpforms-submit-173, .request-sample-submit, .support-form .button.submit, #wpforms-submit-1572, .register-form .submit');
	if(formSubmit.length){
		formSubmit.on('click', function(e){
			fbq('track', 'Lead');
		});
	}
}

export default ( ( $ ) => $( Layout ) )( jQuery );
